import { render } from "./ResendDocumentMail.vue?vue&type=template&id=45a8af2d&scoped=true"
import script from "./ResendDocumentMail.vue?vue&type=script&lang=js"
export * from "./ResendDocumentMail.vue?vue&type=script&lang=js"

import "./ResendDocumentMail.vue?vue&type=style&index=0&id=45a8af2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a8af2d"]])

export default __exports__